<kett-menu-bar></kett-menu-bar>
<!-- <kett-banner></kett-banner> -->
<kett-search-form></kett-search-form>
<!-- <div class="col-12 col-lg-8 offset-lg-2 my-3" style=" min-height: 500px;" id="preview_content">
  <kett-refund-cod-form></kett-refund-cod-form>
</div>  -->




<div class="col-12 col-lg-8 offset-lg-2 my-3" style=" min-height: 500px;" id="preview_content">
  <router-outlet>
  </router-outlet>
</div>

<div class="col-12 footer-bg d-block d-sm-block d-md-block d-lg-none d-xl-none p-1">
  <div class="d-flex flex-row flex-wrap align-items-center justify-content-center">
    <img class="px-1" src="assets/resource/ke_icon.png" width="40">
    <span class="text-1034 px-1" style="color: white;">{{'g.download-mobile-app'|translate}}</span>
    <a href="https://play.google.com/store/apps/details?id=kerry.express.th.mobile.tracking&amp;hl=th" class="px-1"
      target="_blank">
      <img src="assets/resource/google-play.png" width="60"> </a>

    <a href="https://itunes.apple.com/th/app/kerry-express/id909585896?l=th&amp;mt=8" target="_blank" class="icon ios"
      class="px-1">
      <img src="assets/resource/apple-store.png" width="60">
    </a>

  </div>
</div>
